<template>
  <div class="MAIN">
    <headerVisualization></headerVisualization>
    <div class="contain"
         :style="{ backgroundImage: 'url(' + srcImgUrl + ')', backgroundRepeat: 'no-repeat', 'background-size': 'cover' }">
      <div class="leftContain">
        <Map :mapstyle="mapstyle"></Map>
      </div>
      <div class="rightContain">
        <flow-column></flow-column>
        <raw-water-column></raw-water-column>
        <water-fault-alarm></water-fault-alarm>
        <monitoring-management></monitoring-management>
      </div>
    </div>
  </div>
</template>

<script>
import headerVisualization from './modules/headerVisualization'
import FlowColumn from './modules/FlowColumn'
import RawWaterColumn from './modules/RawWaterColumn'
import WaterFaultAlarm from './modules/WaterFaultAlarm'
import MonitoringManagement from './modules/MonitoringManagement'
import Map from '@/views/Water-source-monitoring/components/map'
export default {
  name: 'WaterSourceMonitoring',
  components: {
    headerVisualization,
    FlowColumn,
    RawWaterColumn,
    WaterFaultAlarm,
    MonitoringManagement,
    Map
  },
  data () {
    return {
      srcImgUrl: '/bg.png',
      showPumpList: false,
      mapstyle: {
        width: '100%',
        height: '954px'
      }
    }
  },
  created () {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.MAIN {
  width: 100vw;
  max-width: 100%;
  min-height: 100vh;
  background-color: rgb(0, 25, 46);
  position: relative;

  .contain {
    z-index: 1;
    // height: calc(100vh - 58px);
    padding: 14px;
    // padding-bottom: 26px;
    padding-left: 24px;
    padding-top: 42px;
    padding-right: 24px;
    height: 100%;
    height: 1022px;
    width: 100vw;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .leftContain {
      width: 1248px;
      height: 954px;
      padding: 0;
      overflow: hidden;
      // background: rgba(4, 8, 40, 0.75);
      // border: 1px solid #2f7ba3;
      // opacity: 0.8;
      // box-shadow: inset 0 0 46px 0 rgba(60, 162, 255, 0.39);
      // display: flex;
      // position: relative;
      // margin-bottom: 24px;
    }
    .rightContain {
      width: 600px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      //   border: red solid 1px;
    }
    // position: relative;
  }
  .bannerTitle {
    height: 46px;
    position: absolute;
    top: 129px;
    left: 63px;
    display: flex;
    align-items: center;
    .bannerTip {
      height: 28px;
      width: 6px;
      background: #10c0ff;
    }
    span {
      margin-left: 12px;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 34px;
      color: #10c0ff;
      font-weight: 600;
    }
  }
  .positionItem {
    display: inline-block;
    position: absolute;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #00f6ff;
    font-weight: 400;
  }
  .positionWarp {
    display: flex;
    flex-direction: row;
    width: 1000px;
    .positon-mix {
      // position: absolute;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 40px;
      margin-left: 93px;
      width: 100%;
      .mixTitle {
        width: 20px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 20px;
        color: #00f6ff;
        font-weight: 600;
      }
      .mixRightBox {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100px;
        .mixRightItem {
          margin-top: 8px;
          margin-left: 8px;
          background: rgba(8, 54, 100, 0.8);
          height: 42px;
          width: 202px;
          display: flex;
          align-items: center;
          padding: 12px 14px;
          justify-content: space-between;

          .itemVal {
            font-family: MicrosoftYaHeiSemibold;
            font-size: 16px;
            color: #10c0ff;
            text-align: right;
            font-weight: 600;
          }
          .mixRightItem-Left {
            display: flex;
            align-items: center;
            .itemTitle {
              font-family: MicrosoftYaHeiSemibold;
              font-size: 14px;
              color: #099bfb;
              font-weight: 600;
              margin-left: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
